import { ref, onMounted } from "vue";
import { ICityRegionMapping } from "../types";

const cityRegionJson = {
  cities: [
    {
      city: "MEDELLIN",
      region: "ANTIOQUIA",
    },
    {
      city: "ABEJORRAL",
      region: "ANTIOQUIA",
    },
    {
      city: "ABRIAQUI",
      region: "ANTIOQUIA",
    },
    {
      city: "ALEJANDRIA",
      region: "ANTIOQUIA",
    },
    {
      city: "AMAGA",
      region: "ANTIOQUIA",
    },
    {
      city: "AMALFI",
      region: "ANTIOQUIA",
    },
    {
      city: "ANDES",
      region: "ANTIOQUIA",
    },
    {
      city: "ANGELOPOLIS",
      region: "ANTIOQUIA",
    },
    {
      city: "ANGOSTURA",
      region: "ANTIOQUIA",
    },
    {
      city: "ANORI",
      region: "ANTIOQUIA",
    },
    {
      city: "SANTAFE DE ANTIOQUIA",
      region: "ANTIOQUIA",
    },
    {
      city: "SEGOVIA",
      region: "ANTIOQUIA",
    },
    {
      city: "ANZA",
      region: "ANTIOQUIA",
    },
    {
      city: "APARTADO",
      region: "ANTIOQUIA",
    },
    {
      city: "ARBOLETES",
      region: "ANTIOQUIA",
    },
    {
      city: "ARGELIA",
      region: "ANTIOQUIA",
    },
    {
      city: "ARENAL",
      region: "BOLIVAR",
    },
    {
      city: "ARMENIA",
      region: "ANTIOQUIA",
    },
    {
      city: "BARBOSA",
      region: "ANTIOQUIA",
    },
    {
      city: "BELMIRA",
      region: "ANTIOQUIA",
    },
    {
      city: "BELLO",
      region: "ANTIOQUIA",
    },
    {
      city: "BETANIA",
      region: "ANTIOQUIA",
    },
    {
      city: "BETULIA",
      region: "ANTIOQUIA",
    },
    {
      city: "CIUDAD BOLIVAR",
      region: "ANTIOQUIA",
    },
    {
      city: "BRICENO",
      region: "ANTIOQUIA",
    },
    {
      city: "BURITICA",
      region: "ANTIOQUIA",
    },
    {
      city: "CACERES",
      region: "ANTIOQUIA",
    },
    {
      city: "CAICEDO",
      region: "ANTIOQUIA",
    },
    {
      city: "CALDAS",
      region: "ANTIOQUIA",
    },
    {
      city: "CAMPAMENTO",
      region: "ANTIOQUIA",
    },
    {
      city: "CANASGORDAS",
      region: "ANTIOQUIA",
    },
    {
      city: "CARACOLI",
      region: "ANTIOQUIA",
    },
    {
      city: "CARAMANTA",
      region: "ANTIOQUIA",
    },
    {
      city: "CAREPA",
      region: "ANTIOQUIA",
    },
    {
      city: "EL CARMEN DE VIBORAL",
      region: "ANTIOQUIA",
    },
    {
      city: "CAROLINA",
      region: "ANTIOQUIA",
    },
    {
      city: "CAUCASIA",
      region: "ANTIOQUIA",
    },
    {
      city: "CHIGORODO",
      region: "ANTIOQUIA",
    },
    {
      city: "CISNEROS",
      region: "ANTIOQUIA",
    },
    {
      city: "COCORNA",
      region: "ANTIOQUIA",
    },
    {
      city: "CONCEPCION",
      region: "ANTIOQUIA",
    },
    {
      city: "CONCORDIA",
      region: "ANTIOQUIA",
    },
    {
      city: "COPACABANA",
      region: "ANTIOQUIA",
    },
    {
      city: "DABEIBA",
      region: "ANTIOQUIA",
    },
    {
      city: "DONMATIAS",
      region: "ANTIOQUIA",
    },
    {
      city: "EBEJICO",
      region: "ANTIOQUIA",
    },
    {
      city: "EL BAGRE",
      region: "ANTIOQUIA",
    },
    {
      city: "ENTRERRIOS",
      region: "ANTIOQUIA",
    },
    {
      city: "ENVIGADO",
      region: "ANTIOQUIA",
    },
    {
      city: "FREDONIA",
      region: "ANTIOQUIA",
    },
    {
      city: "FRONTINO",
      region: "ANTIOQUIA",
    },
    {
      city: "GIRALDO",
      region: "ANTIOQUIA",
    },
    {
      city: "GIRARDOTA",
      region: "ANTIOQUIA",
    },
    {
      city: "GOMEZ PLATA",
      region: "ANTIOQUIA",
    },
    {
      city: "GRANADA",
      region: "ANTIOQUIA",
    },
    {
      city: "GUADALUPE",
      region: "ANTIOQUIA",
    },
    {
      city: "GUARNE",
      region: "ANTIOQUIA",
    },
    {
      city: "GUATAPE",
      region: "ANTIOQUIA",
    },
    {
      city: "HISPANIA",
      region: "ANTIOQUIA",
    },
    {
      city: "ITAGUI",
      region: "ANTIOQUIA",
    },
    {
      city: "ITUANGO",
      region: "ANTIOQUIA",
    },
    {
      city: "JARDIN",
      region: "ANTIOQUIA",
    },
    {
      city: "JERICO",
      region: "ANTIOQUIA",
    },
    {
      city: "LA CEJA",
      region: "ANTIOQUIA",
    },
    {
      city: "LA ESTRELLA",
      region: "ANTIOQUIA",
    },
    {
      city: "LA PINTADA",
      region: "ANTIOQUIA",
    },
    {
      city: "LA UNION",
      region: "ANTIOQUIA",
    },
    {
      city: "LIBORINA",
      region: "ANTIOQUIA",
    },
    {
      city: "MACEO",
      region: "ANTIOQUIA",
    },
    {
      city: "MARINILLA",
      region: "ANTIOQUIA",
    },
    {
      city: "MONTEBELLO",
      region: "ANTIOQUIA",
    },
    {
      city: "MURINDO",
      region: "ANTIOQUIA",
    },
    {
      city: "MUTATA",
      region: "ANTIOQUIA",
    },
    {
      city: "NARINO",
      region: "ANTIOQUIA",
    },
    {
      city: "NECOCLI",
      region: "ANTIOQUIA",
    },
    {
      city: "NECHI",
      region: "ANTIOQUIA",
    },
    {
      city: "OLAYA",
      region: "ANTIOQUIA",
    },
    {
      city: "PENOL",
      region: "ANTIOQUIA",
    },
    {
      city: "PEQUE",
      region: "ANTIOQUIA",
    },
    {
      city: "PUEBLORRICO",
      region: "ANTIOQUIA",
    },
    {
      city: "PUERTO BERRIO",
      region: "ANTIOQUIA",
    },
    {
      city: "PUERTO NARE",
      region: "ANTIOQUIA",
    },
    {
      city: "PUERTO TRIUNFO",
      region: "ANTIOQUIA",
    },
    {
      city: "REMEDIOS",
      region: "ANTIOQUIA",
    },
    {
      city: "RETIRO",
      region: "ANTIOQUIA",
    },
    {
      city: "RIONEGRO",
      region: "ANTIOQUIA",
    },
    {
      city: "SABANALARGA",
      region: "ANTIOQUIA",
    },
    {
      city: "SABANETA",
      region: "ANTIOQUIA",
    },
    {
      city: "SALGAR",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN ANDRES DE CUERQUIA",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN CARLOS",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN FRANCISCO",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN JERONIMO",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN JOSE DE LA MONTANA",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN JUAN DE URABA",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN LUIS",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN PEDRO DE LOS MILAGROS",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN PEDRO DE URABA",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN RAFAEL",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN ROQUE",
      region: "ANTIOQUIA",
    },
    {
      city: "SAN VICENTE FERRER",
      region: "ANTIOQUIA",
    },
    {
      city: "SANTA BARBARA",
      region: "ANTIOQUIA",
    },
    {
      city: "SANTA ROSA DE OSOS",
      region: "ANTIOQUIA",
    },
    {
      city: "SANTO DOMINGO",
      region: "ANTIOQUIA",
    },
    {
      city: "EL SANTUARIO",
      region: "ANTIOQUIA",
    },
    {
      city: "SONSON",
      region: "ANTIOQUIA",
    },
    {
      city: "SOPETRAN",
      region: "ANTIOQUIA",
    },
    {
      city: "TAMESIS",
      region: "ANTIOQUIA",
    },
    {
      city: "TARAZA",
      region: "ANTIOQUIA",
    },
    {
      city: "TARSO",
      region: "ANTIOQUIA",
    },
    {
      city: "TITIRIBI",
      region: "ANTIOQUIA",
    },
    {
      city: "TOLEDO",
      region: "ANTIOQUIA",
    },
    {
      city: "TURBO",
      region: "ANTIOQUIA",
    },
    {
      city: "URAMITA",
      region: "ANTIOQUIA",
    },
    {
      city: "URRAO",
      region: "ANTIOQUIA",
    },
    {
      city: "VALDIVIA",
      region: "ANTIOQUIA",
    },
    {
      city: "VALPARAISO",
      region: "ANTIOQUIA",
    },
    {
      city: "VEGACHI",
      region: "ANTIOQUIA",
    },
    {
      city: "VENECIA",
      region: "ANTIOQUIA",
    },
    {
      city: "VIGIA DEL FUERTE",
      region: "ANTIOQUIA",
    },
    {
      city: "YALI",
      region: "ANTIOQUIA",
    },
    {
      city: "YARUMAL",
      region: "ANTIOQUIA",
    },
    {
      city: "YOLOMBO",
      region: "ANTIOQUIA",
    },
    {
      city: "YONDO",
      region: "ANTIOQUIA",
    },
    {
      city: "ZARAGOZA",
      region: "ANTIOQUIA",
    },
    {
      city: "BARRANQUILLA",
      region: "ATLANTICO",
    },
    {
      city: "BARANOA",
      region: "ATLANTICO",
    },
    {
      city: "CAMPO DE LA CRUZ",
      region: "ATLANTICO",
    },
    {
      city: "CANDELARIA",
      region: "ATLANTICO",
    },
    {
      city: "GALAPA",
      region: "ATLANTICO",
    },
    {
      city: "JUAN DE ACOSTA",
      region: "ATLANTICO",
    },
    {
      city: "LURUACO",
      region: "ATLANTICO",
    },
    {
      city: "MALAMBO",
      region: "ATLANTICO",
    },
    {
      city: "MANATI",
      region: "ATLANTICO",
    },
    {
      city: "PALMAR DE VARELA",
      region: "ATLANTICO",
    },
    {
      city: "PIOJO",
      region: "ATLANTICO",
    },
    {
      city: "POLONUEVO",
      region: "ATLANTICO",
    },
    {
      city: "PONEDERA",
      region: "ATLANTICO",
    },
    {
      city: "PUERTO COLOMBIA",
      region: "ATLANTICO",
    },
    {
      city: "REPELON",
      region: "ATLANTICO",
    },
    {
      city: "SABANAGRANDE",
      region: "ATLANTICO",
    },
    {
      city: "SABANALARGA",
      region: "ATLANTICO",
    },
    {
      city: "SANTA LUCIA",
      region: "ATLANTICO",
    },
    {
      city: "SANTO TOMAS",
      region: "ATLANTICO",
    },
    {
      city: "SOLEDAD",
      region: "ATLANTICO",
    },
    {
      city: "SUAN",
      region: "ATLANTICO",
    },
    {
      city: "TUBARA",
      region: "ATLANTICO",
    },
    {
      city: "USIACURI",
      region: "ATLANTICO",
    },
    {
      city: "BOGOTA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CARTAGENA",
      region: "BOLIVAR",
    },
    {
      city: "ACHI",
      region: "BOLIVAR",
    },
    {
      city: "ALTOS DEL ROSARIO",
      region: "BOLIVAR",
    },
    {
      city: "ARJONA",
      region: "BOLIVAR",
    },
    {
      city: "ARROYOHONDO",
      region: "BOLIVAR",
    },
    {
      city: "BARRANCO DE LOBA",
      region: "BOLIVAR",
    },
    {
      city: "CALAMAR",
      region: "BOLIVAR",
    },
    {
      city: "CANTAGALLO",
      region: "BOLIVAR",
    },
    {
      city: "CICUCO",
      region: "BOLIVAR",
    },
    {
      city: "CORDOBA",
      region: "BOLIVAR",
    },
    {
      city: "CLEMENCIA",
      region: "BOLIVAR",
    },
    {
      city: "EL CARMEN DE BOLIVAR",
      region: "BOLIVAR",
    },
    {
      city: "EL GUAMO",
      region: "BOLIVAR",
    },
    {
      city: "EL PENON",
      region: "BOLIVAR",
    },
    {
      city: "HATILLO DE LOBA",
      region: "BOLIVAR",
    },
    {
      city: "MAGANGUE",
      region: "BOLIVAR",
    },
    {
      city: "MAHATES",
      region: "BOLIVAR",
    },
    {
      city: "MARGARITA",
      region: "BOLIVAR",
    },
    {
      city: "MARIA LA BAJA",
      region: "BOLIVAR",
    },
    {
      city: "MONTECRISTO",
      region: "BOLIVAR",
    },
    {
      city: "MOMPOS",
      region: "BOLIVAR",
    },
    {
      city: "MORALES",
      region: "BOLIVAR",
    },
    {
      city: "PINILLOS",
      region: "BOLIVAR",
    },
    {
      city: "SAN CRISTOBAL",
      region: "BOLIVAR",
    },
    {
      city: "SAN ESTANISLAO",
      region: "BOLIVAR",
    },
    {
      city: "SAN FERNANDO",
      region: "BOLIVAR",
    },
    {
      city: "SAN JACINTO",
      region: "BOLIVAR",
    },
    {
      city: "SAN JACINTO DEL CAUCA",
      region: "BOLIVAR",
    },
    {
      city: "SAN JUAN NEPOMUCENO",
      region: "BOLIVAR",
    },
    {
      city: "SAN MARTIN DE LOBA",
      region: "BOLIVAR",
    },
    {
      city: "SAN PABLO",
      region: "BOLIVAR",
    },
    {
      city: "SANTA CATALINA",
      region: "BOLIVAR",
    },
    {
      city: "SANTA ROSA",
      region: "BOLIVAR",
    },
    {
      city: "SANTA ROSA DEL SUR",
      region: "BOLIVAR",
    },
    {
      city: "SIMITI",
      region: "BOLIVAR",
    },
    {
      city: "SOPLAVIENTO",
      region: "BOLIVAR",
    },
    {
      city: "TALAIGUA NUEVO",
      region: "BOLIVAR",
    },
    {
      city: "TIQUISIO",
      region: "BOLIVAR",
    },
    {
      city: "TURBACO",
      region: "BOLIVAR",
    },
    {
      city: "TURBANA",
      region: "BOLIVAR",
    },
    {
      city: "VILLANUEVA",
      region: "BOLIVAR",
    },
    {
      city: "ZAMBRANO",
      region: "BOLIVAR",
    },
    {
      city: "TUNJA",
      region: "BOYACA",
    },
    {
      city: "ALMEIDA",
      region: "BOYACA",
    },
    {
      city: "AQUITANIA",
      region: "BOYACA",
    },
    {
      city: "ARCABUCO",
      region: "BOYACA",
    },
    {
      city: "BELEN",
      region: "BOYACA",
    },
    {
      city: "BERBEO",
      region: "BOYACA",
    },
    {
      city: "BETEITIVA",
      region: "BOYACA",
    },
    {
      city: "BOAVITA",
      region: "BOYACA",
    },
    {
      city: "BOYACA",
      region: "BOYACA",
    },
    {
      city: "BRICENO",
      region: "BOYACA",
    },
    {
      city: "BUENAVISTA",
      region: "BOYACA",
    },
    {
      city: "BUSBANZA",
      region: "BOYACA",
    },
    {
      city: "CALDAS",
      region: "BOYACA",
    },
    {
      city: "CAMPOHERMOSO",
      region: "BOYACA",
    },
    {
      city: "CERINZA",
      region: "BOYACA",
    },
    {
      city: "CHINAVITA",
      region: "BOYACA",
    },
    {
      city: "CHIQUINQUIRA",
      region: "BOYACA",
    },
    {
      city: "CHISCAS",
      region: "BOYACA",
    },
    {
      city: "CHITA",
      region: "BOYACA",
    },
    {
      city: "CHITARAQUE",
      region: "BOYACA",
    },
    {
      city: "CHIVATA",
      region: "BOYACA",
    },
    {
      city: "CIENEGA",
      region: "BOYACA",
    },
    {
      city: "COMBITA",
      region: "BOYACA",
    },
    {
      city: "COPER",
      region: "BOYACA",
    },
    {
      city: "CORRALES",
      region: "BOYACA",
    },
    {
      city: "COVARACHIA",
      region: "BOYACA",
    },
    {
      city: "CUBARA",
      region: "BOYACA",
    },
    {
      city: "CUCAITA",
      region: "BOYACA",
    },
    {
      city: "CUITIVA",
      region: "BOYACA",
    },
    {
      city: "CHIQUIZA",
      region: "BOYACA",
    },
    {
      city: "CHIVOR",
      region: "BOYACA",
    },
    {
      city: "DUITAMA",
      region: "BOYACA",
    },
    {
      city: "EL COCUY",
      region: "BOYACA",
    },
    {
      city: "EL ESPINO",
      region: "BOYACA",
    },
    {
      city: "FIRAVITOBA",
      region: "BOYACA",
    },
    {
      city: "FLORESTA",
      region: "BOYACA",
    },
    {
      city: "GACHANTIVA",
      region: "BOYACA",
    },
    {
      city: "GAMEZA",
      region: "BOYACA",
    },
    {
      city: "GARAGOA",
      region: "BOYACA",
    },
    {
      city: "GUACAMAYAS",
      region: "BOYACA",
    },
    {
      city: "GUATEQUE",
      region: "BOYACA",
    },
    {
      city: "GUAYATA",
      region: "BOYACA",
    },
    {
      city: "GUICAN",
      region: "BOYACA",
    },
    {
      city: "IZA",
      region: "BOYACA",
    },
    {
      city: "JENESANO",
      region: "BOYACA",
    },
    {
      city: "JERICO",
      region: "BOYACA",
    },
    {
      city: "LABRANZAGRANDE",
      region: "BOYACA",
    },
    {
      city: "LA CAPILLA",
      region: "BOYACA",
    },
    {
      city: "LA VICTORIA",
      region: "BOYACA",
    },
    {
      city: "LA UVITA",
      region: "BOYACA",
    },
    {
      city: "VILLA DE LEYVA",
      region: "BOYACA",
    },
    {
      city: "MACANAL",
      region: "BOYACA",
    },
    {
      city: "MARIPI",
      region: "BOYACA",
    },
    {
      city: "MIRAFLORES",
      region: "BOYACA",
    },
    {
      city: "MONGUA",
      region: "BOYACA",
    },
    {
      city: "MONGUI",
      region: "BOYACA",
    },
    {
      city: "MONIQUIRA",
      region: "BOYACA",
    },
    {
      city: "MOTAVITA",
      region: "BOYACA",
    },
    {
      city: "MUZO",
      region: "BOYACA",
    },
    {
      city: "NOBSA",
      region: "BOYACA",
    },
    {
      city: "NUEVO COLON",
      region: "BOYACA",
    },
    {
      city: "OICATA",
      region: "BOYACA",
    },
    {
      city: "OTANCHE",
      region: "BOYACA",
    },
    {
      city: "PACHAVITA",
      region: "BOYACA",
    },
    {
      city: "PAEZ",
      region: "BOYACA",
    },
    {
      city: "PAIPA",
      region: "BOYACA",
    },
    {
      city: "PAJARITO",
      region: "BOYACA",
    },
    {
      city: "PANQUEBA",
      region: "BOYACA",
    },
    {
      city: "PAUNA",
      region: "BOYACA",
    },
    {
      city: "PAZ DE RIO",
      region: "BOYACA",
    },
    {
      city: "PAZ DE ARIPORO",
      region: "CASANARE",
    },
    {
      city: "PUERTO BOYACA",
      region: "BOYACA",
    },
    {
      city: "QUIPAMA",
      region: "BOYACA",
    },
    {
      city: "RAMIRIQUI",
      region: "BOYACA",
    },
    {
      city: "RAQUIRA",
      region: "BOYACA",
    },
    {
      city: "RONDON",
      region: "BOYACA",
    },
    {
      city: "SABOYA",
      region: "BOYACA",
    },
    {
      city: "SACHICA",
      region: "BOYACA",
    },
    {
      city: "SAMACA",
      region: "BOYACA",
    },
    {
      city: "SAN EDUARDO",
      region: "BOYACA",
    },
    {
      city: "SAN JOSE DE PARE",
      region: "BOYACA",
    },
    {
      city: "SAN LUIS DE GACENO",
      region: "BOYACA",
    },
    {
      city: "SAN MATEO",
      region: "BOYACA",
    },
    {
      city: "SAN MIGUEL DE SEMA",
      region: "BOYACA",
    },
    {
      city: "SAN PABLO DE BORBUR",
      region: "BOYACA",
    },
    {
      city: "SANTANA",
      region: "BOYACA",
    },
    {
      city: "SANTA MARIA",
      region: "BOYACA",
    },
    {
      city: "SANTA ROSA DE VITERBO",
      region: "BOYACA",
    },
    {
      city: "SATIVANORTE",
      region: "BOYACA",
    },
    {
      city: "SATIVASUR",
      region: "BOYACA",
    },
    {
      city: "SIACHOQUE",
      region: "BOYACA",
    },
    {
      city: "SOATA",
      region: "BOYACA",
    },
    {
      city: "SOCOTA",
      region: "BOYACA",
    },
    {
      city: "SOCHA",
      region: "BOYACA",
    },
    {
      city: "SOGAMOSO",
      region: "BOYACA",
    },
    {
      city: "SOMONDOCO",
      region: "BOYACA",
    },
    {
      city: "SORA",
      region: "BOYACA",
    },
    {
      city: "SOTAQUIRA",
      region: "BOYACA",
    },
    {
      city: "SORACA",
      region: "BOYACA",
    },
    {
      city: "SUSACON",
      region: "BOYACA",
    },
    {
      city: "SUTAMARCHAN",
      region: "BOYACA",
    },
    {
      city: "SUTATENZA",
      region: "BOYACA",
    },
    {
      city: "TENZA",
      region: "BOYACA",
    },
    {
      city: "TIBANA",
      region: "BOYACA",
    },
    {
      city: "TIBASOSA",
      region: "BOYACA",
    },
    {
      city: "TINJACA",
      region: "BOYACA",
    },
    {
      city: "TIPACOQUE",
      region: "BOYACA",
    },
    {
      city: "TOCA",
      region: "BOYACA",
    },
    {
      city: "TOGUI",
      region: "BOYACA",
    },
    {
      city: "TOTA",
      region: "BOYACA",
    },
    {
      city: "TUNUNGUA",
      region: "BOYACA",
    },
    {
      city: "TURMEQUE",
      region: "BOYACA",
    },
    {
      city: "TUTA",
      region: "BOYACA",
    },
    {
      city: "TUTAZA",
      region: "BOYACA",
    },
    {
      city: "UMBITA",
      region: "BOYACA",
    },
    {
      city: "VENTAQUEMADA",
      region: "BOYACA",
    },
    {
      city: "VIRACACHA",
      region: "BOYACA",
    },
    {
      city: "PESCA",
      region: "BOYACA",
    },
    {
      city: "ZETAQUIRA",
      region: "BOYACA",
    },
    {
      city: "MANIZALES",
      region: "CALDAS",
    },
    {
      city: "AGUADAS",
      region: "CALDAS",
    },
    {
      city: "ANSERMA",
      region: "CALDAS",
    },
    {
      city: "ARANZAZU",
      region: "CALDAS",
    },
    {
      city: "CHINCHINA",
      region: "CALDAS",
    },
    {
      city: "FILADELFIA",
      region: "CALDAS",
    },
    {
      city: "LA DORADA",
      region: "CALDAS",
    },
    {
      city: "LA MERCED",
      region: "CALDAS",
    },
    {
      city: "MANZANARES",
      region: "CALDAS",
    },
    {
      city: "MARQUETALIA",
      region: "CALDAS",
    },
    {
      city: "MARULANDA",
      region: "CALDAS",
    },
    {
      city: "NEIRA",
      region: "CALDAS",
    },
    {
      city: "NORCASIA",
      region: "CALDAS",
    },
    {
      city: "PACORA",
      region: "CALDAS",
    },
    {
      city: "PALESTINA",
      region: "CALDAS",
    },
    {
      city: "PENSILVANIA",
      region: "CALDAS",
    },
    {
      city: "RIOSUCIO",
      region: "CALDAS",
    },
    {
      city: "RISARALDA",
      region: "CALDAS",
    },
    {
      city: "SALAMINA",
      region: "CALDAS",
    },
    {
      city: "SAMANA",
      region: "CALDAS",
    },
    {
      city: "SAN JOSE",
      region: "CALDAS",
    },
    {
      city: "SUPIA",
      region: "CALDAS",
    },
    {
      city: "VILLAMARIA",
      region: "CALDAS",
    },
    {
      city: "VITERBO",
      region: "CALDAS",
    },
    {
      city: "BELALCAZAR",
      region: "CALDAS",
    },
    {
      city: "MARMATO",
      region: "CALDAS",
    },
    {
      city: "VICTORIA",
      region: "CALDAS",
    },
    {
      city: "FLORENCIA",
      region: "CAQUETA",
    },
    {
      city: "ALBANIA",
      region: "CAQUETA",
    },
    {
      city: "BELEN DE LOS ANDAQUIES",
      region: "CAQUETA",
    },
    {
      city: "CARTAGENA DEL CHAIRA",
      region: "CAQUETA",
    },
    {
      city: "CURILLO",
      region: "CAQUETA",
    },
    {
      city: "EL DONCELLO",
      region: "CAQUETA",
    },
    {
      city: "EL PAUJIL",
      region: "CAQUETA",
    },
    {
      city: "LA MONTANITA",
      region: "CAQUETA",
    },
    {
      city: "MILAN",
      region: "CAQUETA",
    },
    {
      city: "MORELIA",
      region: "CAQUETA",
    },
    {
      city: "PUERTO RICO",
      region: "CAQUETA",
    },
    {
      city: "SAN JOSE DEL FRAGUA",
      region: "CAQUETA",
    },
    {
      city: "SAN VICENTE DEL CAGUAN",
      region: "CAQUETA",
    },
    {
      city: "SOLANO",
      region: "CAQUETA",
    },
    {
      city: "SOLITA",
      region: "CAQUETA",
    },
    {
      city: "VALPARAISO",
      region: "CAQUETA",
    },

    {
      city: "POPAYAN",
      region: "CAUCA",
    },
    {
      city: "ALMAGUER",
      region: "CAUCA",
    },
    {
      city: "ARGELIA",
      region: "CAUCA",
    },
    {
      city: "BALBOA",
      region: "CAUCA",
    },
    {
      city: "BOLIVAR",
      region: "CAUCA",
    },
    {
      city: "CAJIBIO",
      region: "CAUCA",
    },
    {
      city: "CALDONO",
      region: "CAUCA",
    },
    {
      city: "EL TAMBO",
      region: "CAUCA",
    },
    {
      city: "FLORENCIA",
      region: "CAUCA",
    },
    {
      city: "INZA",
      region: "CAUCA",
    },
    {
      city: "JAMBALO",
      region: "CAUCA",
    },
    {
      city: "LA SIERRA",
      region: "CAUCA",
    },
    {
      city: "LA VEGA",
      region: "CAUCA",
    },
    {
      city: "MIRANDA",
      region: "CAUCA",
    },
    {
      city: "MORALES",
      region: "CAUCA",
    },
    {
      city: "PAEZ",
      region: "CAUCA",
    },
    {
      city: "PATIA",
      region: "CAUCA",
    },
    {
      city: "PIENDAMO",
      region: "CAUCA",
    },
    {
      city: "PUERTO TEJADA",
      region: "CAUCA",
    },
    {
      city: "PURACE",
      region: "CAUCA",
    },
    {
      city: "ROSAS",
      region: "CAUCA",
    },
    {
      city: "SAN SEBASTIAN",
      region: "CAUCA",
    },
    {
      city: "SANTANDER DE QUILICHAO",
      region: "CAUCA",
    },
    {
      city: "SILVIA",
      region: "CAUCA",
    },
    {
      city: "SOTARA",
      region: "CAUCA",
    },
    {
      city: "SUCRE",
      region: "CAUCA",
    },
    {
      city: "TIMBIO",
      region: "CAUCA",
    },
    {
      city: "TOTORO",
      region: "CAUCA",
    },
    {
      city: "VILLA RICA",
      region: "CAUCA",
    },
    {
      city: "BUENOS AIRES",
      region: "CAUCA",
    },
    {
      city: "CALOTO",
      region: "CAUCA",
    },
    {
      city: "CORINTO",
      region: "CAUCA",
    },
    {
      city: "GUACHENE",
      region: "CAUCA",
    },
    {
      city: "GUAPI",
      region: "CAUCA",
    },
    {
      city: "LOPEZ DE MICAY",
      region: "CAUCA",
    },
    {
      city: "MERCADERES",
      region: "CAUCA",
    },
    {
      city: "PADILLA",
      region: "CAUCA",
    },
    {
      city: "PIAMONTE",
      region: "CAUCA",
    },
    {
      city: "SANTA ROSA",
      region: "CAUCA",
    },
    {
      city: "SUAREZ",
      region: "CAUCA",
    },
    {
      city: "TIMBIQUI",
      region: "CAUCA",
    },
    {
      city: "TORIBIO",
      region: "CAUCA",
    },
    {
      city: "VALLEDUPAR",
      region: "CESAR",
    },
    {
      city: "AGUACHICA",
      region: "CESAR",
    },
    {
      city: "AGUSTIN CODAZZI",
      region: "CESAR",
    },
    {
      city: "ASTREA",
      region: "CESAR",
    },
    {
      city: "BECERRIL",
      region: "CESAR",
    },
    {
      city: "BOSCONIA",
      region: "CESAR",
    },
    {
      city: "CHIMICHAGUA",
      region: "CESAR",
    },
    {
      city: "CHIRIGUANA",
      region: "CESAR",
    },
    {
      city: "CURUMANI",
      region: "CESAR",
    },
    {
      city: "EL COPEY",
      region: "CESAR",
    },
    {
      city: "EL PASO",
      region: "CESAR",
    },
    {
      city: "GONZALEZ",
      region: "CESAR",
    },
    {
      city: "LA GLORIA",
      region: "CESAR",
    },
    {
      city: "LA JAGUA DE IBIRICO",
      region: "CESAR",
    },
    {
      city: "MANAURE BALCON DEL CESAR",
      region: "CESAR",
    },
    {
      city: "PAILITAS",
      region: "CESAR",
    },
    {
      city: "PELAYA",
      region: "CESAR",
    },
    {
      city: "PUEBLO BELLO",
      region: "CESAR",
    },
    {
      city: "RIO DE ORO",
      region: "CESAR",
    },
    {
      city: "LA PAZ",
      region: "CESAR",
    },
    {
      city: "SAN DIEGO",
      region: "CESAR",
    },
    {
      city: "SAN MARTIN",
      region: "CESAR",
    },
    {
      city: "GAMARRA",
      region: "CESAR",
    },
    {
      city: "SAN ALBERTO",
      region: "CESAR",
    },
    {
      city: "TAMALAMEQUE",
      region: "CESAR",
    },
    {
      city: "MONTERIA",
      region: "CORDOBA",
    },
    {
      city: "AYAPEL",
      region: "CORDOBA",
    },
    {
      city: "BUENAVISTA",
      region: "CORDOBA",
    },
    {
      city: "CANALETE",
      region: "CORDOBA",
    },
    {
      city: "CERETE",
      region: "CORDOBA",
    },
    {
      city: "CHIMA",
      region: "CORDOBA",
    },
    {
      city: "CHINU",
      region: "CORDOBA",
    },
    {
      city: "CIENAGA DE ORO",
      region: "CORDOBA",
    },
    {
      city: "COTORRA",
      region: "CORDOBA",
    },
    {
      city: "LA APARTADA",
      region: "CORDOBA",
    },
    {
      city: "LORICA",
      region: "CORDOBA",
    },
    {
      city: "MOMIL",
      region: "CORDOBA",
    },
    {
      city: "MONTELIBANO",
      region: "CORDOBA",
    },
    {
      city: "PLANETA RICA",
      region: "CORDOBA",
    },
    {
      city: "PUEBLO NUEVO",
      region: "CORDOBA",
    },
    {
      city: "PUERTO ESCONDIDO",
      region: "CORDOBA",
    },
    {
      city: "SAHAGUN",
      region: "CORDOBA",
    },
    {
      city: "SAN ANDRES DE SOTAVENTO",
      region: "CORDOBA",
    },
    {
      city: "SAN ANTERO",
      region: "CORDOBA",
    },
    {
      city: "SAN BERNARDO DEL VIENTO",
      region: "CORDOBA",
    },
    {
      city: "SAN CARLOS",
      region: "CORDOBA",
    },
    {
      city: "SAN PELAYO",
      region: "CORDOBA",
    },
    {
      city: "TIERRALTA",
      region: "CORDOBA",
    },
    {
      city: "TUCHIN",
      region: "CORDOBA",
    },
    {
      city: "VALENCIA",
      region: "CORDOBA",
    },
    {
      city: "PUERTO LIBERTADOR",
      region: "CORDOBA",
    },
    {
      city: "LOS CORDOBAS",
      region: "CORDOBA",
    },
    {
      city: "MOÑITOS",
      region: "CORDOBA",
    },
    {
      city: "PURISIMA",
      region: "CORDOBA",
    },
    {
      city: "SAN JOSE DE URE",
      region: "CORDOBA",
    },
    {
      city: "AGUA DE DIOS",
      region: "CUNDINAMARCA",
    },
    {
      city: "ALBAN",
      region: "CUNDINAMARCA",
    },
    {
      city: "ANAPOIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "ANOLAIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "ARBELAEZ",
      region: "CUNDINAMARCA",
    },
    {
      city: "BELTRAN",
      region: "CUNDINAMARCA",
    },
    {
      city: "BITUIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "BOJACA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CABRERA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CACHIPAY",
      region: "CUNDINAMARCA",
    },
    {
      city: "CAJICA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CAPARRAPI",
      region: "CUNDINAMARCA",
    },
    {
      city: "CAQUEZA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CARMEN DE CARUPA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CHAGUANI",
      region: "CUNDINAMARCA",
    },
    {
      city: "CHIA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CHIPAQUE",
      region: "CUNDINAMARCA",
    },
    {
      city: "CHOACHI",
      region: "CUNDINAMARCA",
    },
    {
      city: "CHOCONTA",
      region: "CUNDINAMARCA",
    },
    {
      city: "COGUA",
      region: "CUNDINAMARCA",
    },
    {
      city: "COTA",
      region: "CUNDINAMARCA",
    },
    {
      city: "CUCUNUBA",
      region: "CUNDINAMARCA",
    },
    {
      city: "EL COLEGIO",
      region: "CUNDINAMARCA",
    },
    {
      city: "EL PENON",
      region: "CUNDINAMARCA",
    },
    {
      city: "EL ROSAL",
      region: "CUNDINAMARCA",
    },
    {
      city: "FACATATIVA",
      region: "CUNDINAMARCA",
    },
    {
      city: "FOMEQUE",
      region: "CUNDINAMARCA",
    },
    {
      city: "FOSCA",
      region: "CUNDINAMARCA",
    },
    {
      city: "FUNZA",
      region: "CUNDINAMARCA",
    },
    {
      city: "FUQUENE",
      region: "CUNDINAMARCA",
    },
    {
      city: "FUSAGASUGA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GACHALA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GACHANCIPA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GACHETA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GAMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GIRARDOT",
      region: "CUNDINAMARCA",
    },
    {
      city: "GRANADA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUACHETA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUADUAS",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUASCA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUATAQUI",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUATAVITA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUAYABAL DE SIQUIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUAYABETAL",
      region: "CUNDINAMARCA",
    },
    {
      city: "GUTIERREZ",
      region: "CUNDINAMARCA",
    },
    {
      city: "JERUSALEN",
      region: "CUNDINAMARCA",
    },
    {
      city: "JUNIN",
      region: "CUNDINAMARCA",
    },
    {
      city: "LA CALERA",
      region: "CUNDINAMARCA",
    },
    {
      city: "LA MESA",
      region: "CUNDINAMARCA",
    },
    {
      city: "LA PALMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "LA PENA",
      region: "CUNDINAMARCA",
    },
    {
      city: "LA VEGA",
      region: "CUNDINAMARCA",
    },
    {
      city: "LENGUAZAQUE",
      region: "CUNDINAMARCA",
    },
    {
      city: "MACHETA",
      region: "CUNDINAMARCA",
    },
    {
      city: "MADRID",
      region: "CUNDINAMARCA",
    },
    {
      city: "MANTA",
      region: "CUNDINAMARCA",
    },
    {
      city: "MEDINA",
      region: "CUNDINAMARCA",
    },
    {
      city: "MOSQUERA",
      region: "CUNDINAMARCA",
    },
    {
      city: "NARINO",
      region: "CUNDINAMARCA",
    },
    {
      city: "NEMOCON",
      region: "CUNDINAMARCA",
    },
    {
      city: "NILO",
      region: "CUNDINAMARCA",
    },
    {
      city: "NIMAIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "NOCAIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "VENECIA",
      region: "CUNDINAMARCA",
    },
    {
      city: "PACHO",
      region: "CUNDINAMARCA",
    },
    {
      city: "PAIME",
      region: "CUNDINAMARCA",
    },
    {
      city: "PANDI",
      region: "CUNDINAMARCA",
    },
    {
      city: "PARATEBUENO",
      region: "CUNDINAMARCA",
    },
    {
      city: "PASCA",
      region: "CUNDINAMARCA",
    },
    {
      city: "PUERTO SALGAR",
      region: "CUNDINAMARCA",
    },
    {
      city: "PULI",
      region: "CUNDINAMARCA",
    },
    {
      city: "QUEBRADANEGRA",
      region: "CUNDINAMARCA",
    },
    {
      city: "QUETAME",
      region: "CUNDINAMARCA",
    },
    {
      city: "QUIPILE",
      region: "CUNDINAMARCA",
    },
    {
      city: "APULO",
      region: "CUNDINAMARCA",
    },
    {
      city: "RICAURTE",
      region: "CUNDINAMARCA",
    },
    {
      city: "SAN ANTONIO DEL TEQUENDAMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SAN BERNARDO",
      region: "CUNDINAMARCA",
    },
    {
      city: "SAN CAYETANO",
      region: "CUNDINAMARCA",
    },
    {
      city: "SAN FRANCISCO",
      region: "CUNDINAMARCA",
    },
    {
      city: "SAN JUAN DE RIOSECO",
      region: "CUNDINAMARCA",
    },
    {
      city: "SASAIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SESQUILE",
      region: "CUNDINAMARCA",
    },
    {
      city: "SIBATE",
      region: "CUNDINAMARCA",
    },
    {
      city: "SILVANIA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SIMIJACA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SOACHA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SOPO",
      region: "CUNDINAMARCA",
    },
    {
      city: "SUBACHOQUE",
      region: "CUNDINAMARCA",
    },
    {
      city: "SUESCA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SUPATA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SUSA",
      region: "CUNDINAMARCA",
    },
    {
      city: "SUTATAUSA",
      region: "CUNDINAMARCA",
    },
    {
      city: "TABIO",
      region: "CUNDINAMARCA",
    },
    {
      city: "TAUSA",
      region: "CUNDINAMARCA",
    },
    {
      city: "TENA",
      region: "CUNDINAMARCA",
    },
    {
      city: "TENJO",
      region: "CUNDINAMARCA",
    },
    {
      city: "TIBACUY",
      region: "CUNDINAMARCA",
    },
    {
      city: "TIBIRITA",
      region: "CUNDINAMARCA",
    },
    {
      city: "TOCAIMA",
      region: "CUNDINAMARCA",
    },
    {
      city: "TOCANCIPA",
      region: "CUNDINAMARCA",
    },
    {
      city: "TOPAIPI",
      region: "CUNDINAMARCA",
    },
    {
      city: "UBALA",
      region: "CUNDINAMARCA",
    },
    {
      city: "UBAQUE",
      region: "CUNDINAMARCA",
    },
    {
      city: "VILLA DE SAN DIEGO DE UBATE",
      region: "CUNDINAMARCA",
    },
    {
      city: "UNE",
      region: "CUNDINAMARCA",
    },
    {
      city: "UTICA",
      region: "CUNDINAMARCA",
    },
    {
      city: "VERGARA",
      region: "CUNDINAMARCA",
    },
    {
      city: "VIANI",
      region: "CUNDINAMARCA",
    },
    {
      city: "VILLAGOMEZ",
      region: "CUNDINAMARCA",
    },
    {
      city: "VILLAPINZON",
      region: "CUNDINAMARCA",
    },
    {
      city: "VILLETA",
      region: "CUNDINAMARCA",
    },
    {
      city: "VIOTA",
      region: "CUNDINAMARCA",
    },
    {
      city: "YACOPI",
      region: "CUNDINAMARCA",
    },
    {
      city: "ZIPACON",
      region: "CUNDINAMARCA",
    },
    {
      city: "ZIPAQUIRA",
      region: "CUNDINAMARCA",
    },
    {
      city: "QUIBDO",
      region: "CHOCO",
    },
    {
      city: "ACANDI",
      region: "CHOCO",
    },
    {
      city: "ALTO BAUDO",
      region: "CHOCO",
    },
    {
      city: "ATRATO",
      region: "CHOCO",
    },
    {
      city: "BAGADO",
      region: "CHOCO",
    },
    {
      city: "BAHIA SOLANO",
      region: "CHOCO",
    },
    {
      city: "BAJO BAUDO",
      region: "CHOCO",
    },
    {
      city: "BOJAYA",
      region: "CHOCO",
    },
    {
      city: "CARMEN DEL DARIEN",
      region: "CHOCO",
    },
    {
      city: "CERTEGUI",
      region: "CHOCO",
    },
    {
      city: "CONDOTO",
      region: "CHOCO",
    },
    {
      city: "EL CANTON DEL SAN PABLO",
      region: "CHOCO",
    },
    {
      city: "EL CARMEN DE ATRATO",
      region: "CHOCO",
    },
    {
      city: "ISTMINA",
      region: "CHOCO",
    },
    {
      city: "JURADO",
      region: "CHOCO",
    },
    {
      city: "LITORAL DEL SAN JUAN",
      region: "CHOCO",
    },
    {
      city: "LLORO",
      region: "CHOCO",
    },
    {
      city: "MEDIO ATRATO",
      region: "CHOCO",
    },
    {
      city: "MEDIO BAUDO",
      region: "CHOCO",
    },
    {
      city: "MEDIO SAN JUAN",
      region: "CHOCO",
    },
    {
      city: "NOVITA",
      region: "CHOCO",
    },
    {
      city: "NUQUI",
      region: "CHOCO",
    },
    {
      city: "RIO IRO",
      region: "CHOCO",
    },
    {
      city: "RIO QUITO",
      region: "CHOCO",
    },
    {
      city: "RIOSUCIO",
      region: "CHOCO",
    },
    {
      city: "SAN JOSE DEL PALMAR",
      region: "CHOCO",
    },
    {
      city: "SIPI",
      region: "CHOCO",
    },
    {
      city: "TADO",
      region: "CHOCO",
    },
    {
      city: "UNGUIA",
      region: "CHOCO",
    },
    {
      city: "UNION PANAMERICANA",
      region: "CHOCO",
    },
    {
      city: "NUEVO BELEN DE BAJIRA",
      region: "CHOCO",
    },
    {
      city: "NEIVA",
      region: "HUILA",
    },
    {
      city: "ACEVEDO",
      region: "HUILA",
    },
    {
      city: "ALTAMIRA",
      region: "HUILA",
    },
    {
      city: "AGRADO",
      region: "HUILA",
    },
    {
      city: "AIPE",
      region: "HUILA",
    },
    {
      city: "ALGECIRAS",
      region: "HUILA",
    },
    {
      city: "BARAYA",
      region: "HUILA",
    },
    {
      city: "CAMPOALEGRE",
      region: "HUILA",
    },
    {
      city: "COLOMBIA",
      region: "HUILA",
    },
    {
      city: "ELIAS",
      region: "HUILA",
    },
    {
      city: "GARZON",
      region: "HUILA",
    },
    {
      city: "GIGANTE",
      region: "HUILA",
    },
    {
      city: "GUADALUPE",
      region: "HUILA",
    },
    {
      city: "HOBO",
      region: "HUILA",
    },
    {
      city: "IQUIRA",
      region: "HUILA",
    },
    {
      city: "ISNOS",
      region: "HUILA",
    },
    {
      city: "LA ARGENTINA",
      region: "HUILA",
    },
    {
      city: "LA PLATA",
      region: "HUILA",
    },
    {
      city: "NATAGA",
      region: "HUILA",
    },
    {
      city: "OPORAPA",
      region: "HUILA",
    },
    {
      city: "PAICOL",
      region: "HUILA",
    },
    {
      city: "PALERMO",
      region: "HUILA",
    },
    {
      city: "PALESTINA",
      region: "HUILA",
    },
    {
      city: "PITAL",
      region: "HUILA",
    },
    {
      city: "PITALITO",
      region: "HUILA",
    },
    {
      city: "RIVERA",
      region: "HUILA",
    },
    {
      city: "SALADOBLANCO",
      region: "HUILA",
    },
    {
      city: "SAN AGUSTIN",
      region: "HUILA",
    },
    {
      city: "SANTA MARIA",
      region: "HUILA",
    },
    {
      city: "SUAZA",
      region: "HUILA",
    },
    {
      city: "TARQUI",
      region: "HUILA",
    },
    {
      city: "TESALIA",
      region: "HUILA",
    },
    {
      city: "TELLO",
      region: "HUILA",
    },
    {
      city: "TERUEL",
      region: "HUILA",
    },
    {
      city: "TIMANA",
      region: "HUILA",
    },
    {
      city: "VILLAVIEJA",
      region: "HUILA",
    },
    {
      city: "YAGUARA",
      region: "HUILA",
    },

    {
      city: "RIOHACHA",
      region: "LA GUAJIRA",
    },
    {
      city: "ALBANIA",
      region: "LA GUAJIRA",
    },
    {
      city: "DISTRACCION",
      region: "LA GUAJIRA",
    },
    {
      city: "FONSECA",
      region: "LA GUAJIRA",
    },
    {
      city: "HATONUEVO",
      region: "LA GUAJIRA",
    },
    {
      city: "LA JAGUA DEL PILAR",
      region: "LA GUAJIRA",
    },
    {
      city: "MAICAO",
      region: "LA GUAJIRA",
    },
    {
      city: "SAN JUAN DEL CESAR",
      region: "LA GUAJIRA",
    },
    {
      city: "URUMITA",
      region: "LA GUAJIRA",
    },
    {
      city: "VILLANUEVA",
      region: "LA GUAJIRA",
    },
    {
      city: "BARRANCAS",
      region: "LA GUAJIRA",
    },
    {
      city: "DIBULLA",
      region: "LA GUAJIRA",
    },
    {
      city: "EL MOLINO",
      region: "LA GUAJIRA",
    },
    {
      city: "MANAURE",
      region: "LA GUAJIRA",
    },
    {
      city: "URIBIA",
      region: "LA GUAJIRA",
    },
    {
      city: "SANTA MARTA",
      region: "MAGDALENA",
    },
    {
      city: "ALGARROBO",
      region: "MAGDALENA",
    },
    {
      city: "ARACATACA",
      region: "MAGDALENA",
    },
    {
      city: "ARIGUANI",
      region: "MAGDALENA",
    },
    {
      city: "CERRO DE SAN ANTONIO",
      region: "MAGDALENA",
    },
    {
      city: "CHIVOLO",
      region: "MAGDALENA",
    },
    {
      city: "CIENAGA",
      region: "MAGDALENA",
    },
    {
      city: "CONCORDIA",
      region: "MAGDALENA",
    },
    {
      city: "EL BANCO",
      region: "MAGDALENA",
    },
    {
      city: "EL PINON",
      region: "MAGDALENA",
    },
    {
      city: "EL RETEN",
      region: "MAGDALENA",
    },
    {
      city: "FUNDACION",
      region: "MAGDALENA",
    },
    {
      city: "GUAMAL",
      region: "MAGDALENA",
    },
    {
      city: "NUEVA GRANADA",
      region: "MAGDALENA",
    },
    {
      city: "PEDRAZA",
      region: "MAGDALENA",
    },
    {
      city: "PIJINO DEL CARMEN",
      region: "MAGDALENA",
    },
    {
      city: "PIVIJAY",
      region: "MAGDALENA",
    },
    {
      city: "PLATO",
      region: "MAGDALENA",
    },
    {
      city: "PUEBLOVIEJO",
      region: "MAGDALENA",
    },
    {
      city: "REMOLINO",
      region: "MAGDALENA",
    },
    {
      city: "SALAMINA",
      region: "MAGDALENA",
    },
    {
      city: "SAN SEBASTIAN DE BUENAVISTA",
      region: "MAGDALENA",
    },
    {
      city: "SAN ZENON",
      region: "MAGDALENA",
    },
    {
      city: "SANTA ANA",
      region: "MAGDALENA",
    },
    {
      city: "SANTA BARBARA DE PINTO",
      region: "MAGDALENA",
    },
    {
      city: "SITIONUEVO",
      region: "MAGDALENA",
    },
    {
      city: "TENERIFE",
      region: "MAGDALENA",
    },
    {
      city: "ZONA BANANERA",
      region: "MAGDALENA",
    },
    {
      city: "SABANAS DE SAN ANGEL",
      region: "MAGDALENA",
    },
    {
      city: "ZAPAYAN",
      region: "MAGDALENA",
    },
    {
      city: "VILLAVICENCIO",
      region: "META",
    },
    {
      city: "ACACIAS",
      region: "META",
    },
    {
      city: "CASTILLA LA NUEVA",
      region: "META",
    },
    {
      city: "SAN LUIS DE CUBARRAL",
      region: "META",
    },
    {
      city: "CUMARAL",
      region: "META",
    },
    {
      city: "EL CASTILLO",
      region: "META",
    },
    {
      city: "EL DORADO",
      region: "META",
    },
    {
      city: "GRANADA",
      region: "META",
    },
    {
      city: "GUAMAL",
      region: "META",
    },
    {
      city: "PUERTO GAITAN",
      region: "META",
    },
    {
      city: "PUERTO LOPEZ",
      region: "META",
    },
    {
      city: "RESTREPO",
      region: "META",
    },
    {
      city: "SAN CARLOS DE GUAROA",
      region: "META",
    },
    {
      city: "PASTO",
      region: "NARINO",
    },
    {
      city: "ALBAN",
      region: "NARINO",
    },
    {
      city: "ALDANA",
      region: "NARINO",
    },
    {
      city: "ANCUYA",
      region: "NARINO",
    },
    {
      city: "ARBOLEDA",
      region: "NARINO",
    },
    {
      city: "BELEN",
      region: "NARINO",
    },
    {
      city: "BUESACO",
      region: "NARINO",
    },
    {
      city: "COLON",
      region: "NARINO",
    },
    {
      city: "CONSACA",
      region: "NARINO",
    },
    {
      city: "CONTADERO",
      region: "NARINO",
    },
    {
      city: "CORDOBA",
      region: "NARINO",
    },
    {
      city: "CUASPUD",
      region: "NARINO",
    },
    {
      city: "CUMBAL",
      region: "NARINO",
    },
    {
      city: "CUMBITARA",
      region: "NARINO",
    },
    {
      city: "CHACHAGUI",
      region: "NARINO",
    },
    {
      city: "EL PENOL",
      region: "NARINO",
    },
    {
      city: "EL ROSARIO",
      region: "NARINO",
    },
    {
      city: "EL TABLON DE GOMEZ",
      region: "NARINO",
    },
    {
      city: "EL TAMBO",
      region: "NARINO",
    },
    {
      city: "FUNES",
      region: "NARINO",
    },
    {
      city: "GUACHUCAL",
      region: "NARINO",
    },
    {
      city: "GUAITARILLA",
      region: "NARINO",
    },
    {
      city: "GUALMATAN",
      region: "NARINO",
    },
    {
      city: "ILES",
      region: "NARINO",
    },
    {
      city: "IMUES",
      region: "NARINO",
    },
    {
      city: "IPIALES",
      region: "NARINO",
    },
    {
      city: "LA CRUZ",
      region: "NARINO",
    },
    {
      city: "LA FLORIDA",
      region: "NARINO",
    },
    {
      city: "LA LLANADA",
      region: "NARINO",
    },
    {
      city: "LA UNION",
      region: "NARINO",
    },
    {
      city: "LEIVA",
      region: "NARINO",
    },
    {
      city: "LINARES",
      region: "NARINO",
    },
    {
      city: "LOS ANDES",
      region: "NARINO",
    },
    {
      city: "MALLAMA",
      region: "NARINO",
    },
    {
      city: "NARINO",
      region: "NARINO",
    },
    {
      city: "OSPINA",
      region: "NARINO",
    },
    {
      city: "POLICARPA",
      region: "NARINO",
    },
    {
      city: "POTOSI",
      region: "NARINO",
    },
    {
      city: "PROVIDENCIA",
      region: "NARINO",
    },
    {
      city: "PUERRES",
      region: "NARINO",
    },
    {
      city: "PUPIALES",
      region: "NARINO",
    },
    {
      city: "RICAURTE",
      region: "NARINO",
    },
    {
      city: "SAMANIEGO",
      region: "NARINO",
    },
    {
      city: "SANDONA",
      region: "NARINO",
    },
    {
      city: "SAN BERNARDO",
      region: "NARINO",
    },
    {
      city: "SAN LORENZO",
      region: "NARINO",
    },
    {
      city: "SAN PABLO",
      region: "NARINO",
    },
    {
      city: "SAN PEDRO DE CARTAGO",
      region: "NARINO",
    },
    {
      city: "SANTACRUZ",
      region: "NARINO",
    },
    {
      city: "SAPUYES",
      region: "NARINO",
    },
    {
      city: "TAMINANGO",
      region: "NARINO",
    },
    {
      city: "TANGUA",
      region: "NARINO",
    },
    {
      city: "SAN ANDRES DE TUMACO",
      region: "NARINO",
    },
    {
      city: "TUQUERRES",
      region: "NARINO",
    },
    {
      city: "YACUANQUER",
      region: "NARINO",
    },
    {
      city: "CUCUTA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "ABREGO",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "ARBOLEDAS",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "BOCHALEMA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "BUCARASICA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "CACOTA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "CACHIRA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "CHINACOTA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "CONVENCION",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "DURANIA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "EL CARMEN",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "EL ZULIA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "GRAMALOTE",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "HACARI",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "HERRAN",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "LABATECA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "LA ESPERANZA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "LA PLAYA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "LOS PATIOS",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "LOURDES",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "MUTISCUA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "OCANA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "PAMPLONA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "PAMPLONITA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "PUERTO SANTANDER",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "RAGONVALIA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "SALAZAR",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "SAN CAYETANO",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "SANTIAGO",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "SARDINATA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "SILOS",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "TEORAMA",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "TIBU",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "TOLEDO",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "VILLA CARO",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "VILLA DEL ROSARIO",
      region: "NORTE DE SANTANDER",
    },
    {
      city: "ARMENIA",
      region: "QUINDIO",
    },
    {
      city: "BUENAVISTA",
      region: "QUINDIO",
    },
    {
      city: "CALARCA",
      region: "QUINDIO",
    },
    {
      city: "CIRCASIA",
      region: "QUINDIO",
    },
    {
      city: "CORDOBA",
      region: "QUINDIO",
    },
    {
      city: "FILANDIA",
      region: "QUINDIO",
    },
    {
      city: "GENOVA",
      region: "QUINDIO",
    },
    {
      city: "LA TEBAIDA",
      region: "QUINDIO",
    },
    {
      city: "MONTENEGRO",
      region: "QUINDIO",
    },
    {
      city: "PIJAO",
      region: "QUINDIO",
    },
    {
      city: "QUIMBAYA",
      region: "QUINDIO",
    },
    {
      city: "SALENTO",
      region: "QUINDIO",
    },
    {
      city: "PEREIRA",
      region: "RISARALDA",
    },
    {
      city: "APIA",
      region: "RISARALDA",
    },
    {
      city: "BALBOA",
      region: "RISARALDA",
    },
    {
      city: "BELEN DE UMBRIA",
      region: "RISARALDA",
    },
    {
      city: "DOSQUEBRADAS",
      region: "RISARALDA",
    },
    {
      city: "GUATICA",
      region: "RISARALDA",
    },
    {
      city: "LA CELIA",
      region: "RISARALDA",
    },
    {
      city: "LA VIRGINIA",
      region: "RISARALDA",
    },
    {
      city: "MARSELLA",
      region: "RISARALDA",
    },
    {
      city: "MISTRATO",
      region: "RISARALDA",
    },
    {
      city: "PUEBLO RICO",
      region: "RISARALDA",
    },
    {
      city: "QUINCHIA",
      region: "RISARALDA",
    },
    {
      city: "SANTA ROSA DE CABAL",
      region: "RISARALDA",
    },
    {
      city: "SANTUARIO",
      region: "RISARALDA",
    },
    {
      city: "BUCARAMANGA",
      region: "SANTANDER",
    },
    {
      city: "AGUADA",
      region: "SANTANDER",
    },
    {
      city: "ALBANIA",
      region: "SANTANDER",
    },
    {
      city: "BARBOSA",
      region: "SANTANDER",
    },
    {
      city: "BARICHARA",
      region: "SANTANDER",
    },
    {
      city: "BARRANCABERMEJA",
      region: "SANTANDER",
    },
    {
      city: "BETULIA",
      region: "SANTANDER",
    },
    {
      city: "BOLIVAR",
      region: "SANTANDER",
    },
    {
      city: "CHARALA",
      region: "SANTANDER",
    },
    {
      city: "CHIPATA",
      region: "SANTANDER",
    },
    {
      city: "CIMITARRA",
      region: "SANTANDER",
    },
    {
      city: "CURITI",
      region: "SANTANDER",
    },
    {
      city: "EL CARMEN DE CHUCURI",
      region: "SANTANDER",
    },
    {
      city: "EL PENON",
      region: "SANTANDER",
    },
    {
      city: "EL PLAYON",
      region: "SANTANDER",
    },
    {
      city: "FLORIAN",
      region: "SANTANDER",
    },
    {
      city: "FLORIDABLANCA",
      region: "SANTANDER",
    },
    {
      city: "GAMBITA",
      region: "SANTANDER",
    },
    {
      city: "GIRON",
      region: "SANTANDER",
    },
    {
      city: "GUAVATA",
      region: "SANTANDER",
    },
    {
      city: "GUEPSA",
      region: "SANTANDER",
    },
    {
      city: "JESUS MARIA",
      region: "SANTANDER",
    },
    {
      city: "LA BELLEZA",
      region: "SANTANDER",
    },
    {
      city: "LANDAZURI",
      region: "SANTANDER",
    },
    {
      city: "LA PAZ",
      region: "SANTANDER",
    },
    {
      city: "LEBRIJA",
      region: "SANTANDER",
    },
    {
      city: "LOS SANTOS",
      region: "SANTANDER",
    },
    {
      city: "MALAGA",
      region: "SANTANDER",
    },
    {
      city: "OIBA",
      region: "SANTANDER",
    },
    {
      city: "PARAMO",
      region: "SANTANDER",
    },
    {
      city: "PIEDECUESTA",
      region: "SANTANDER",
    },
    {
      city: "PINCHOTE",
      region: "SANTANDER",
    },
    {
      city: "PUENTE NACIONAL",
      region: "SANTANDER",
    },
    {
      city: "PUERTO WILCHES",
      region: "SANTANDER",
    },
    {
      city: "RIONEGRO",
      region: "SANTANDER",
    },
    {
      city: "SABANA DE TORRES",
      region: "SANTANDER",
    },
    {
      city: "SAN GIL",
      region: "SANTANDER",
    },
    {
      city: "SAN VICENTE DE CHUCURI",
      region: "SANTANDER",
    },
    {
      city: "SANTA HELENA DEL OPON",
      region: "SANTANDER",
    },
    {
      city: "SOCORRO",
      region: "SANTANDER",
    },
    {
      city: "SUAITA",
      region: "SANTANDER",
    },
    {
      city: "SUCRE",
      region: "SANTANDER",
    },
    {
      city: "VALLE DE SAN JOSE",
      region: "SANTANDER",
    },
    {
      city: "VELEZ",
      region: "SANTANDER",
    },
    {
      city: "VILLANUEVA",
      region: "SANTANDER",
    },
    {
      city: "ZAPATOCA",
      region: "SANTANDER",
    },
    {
      city: "SINCELEJO",
      region: "SUCRE",
    },
    {
      city: "BUENAVISTA",
      region: "SUCRE",
    },
    {
      city: "COLOSO",
      region: "SUCRE",
    },
    {
      city: "COROZAL",
      region: "SUCRE",
    },
    {
      city: "COVENAS",
      region: "SUCRE",
    },
    {
      city: "CHALAN",
      region: "SUCRE",
    },
    {
      city: "GALERAS",
      region: "SUCRE",
    },
    {
      city: "GUARANDA",
      region: "SUCRE",
    },
    {
      city: "LA UNION",
      region: "SUCRE",
    },
    {
      city: "LOS PALMITOS",
      region: "SUCRE",
    },
    {
      city: "MAJAGUAL",
      region: "SUCRE",
    },
    {
      city: "MORROA",
      region: "SUCRE",
    },
    {
      city: "OVEJAS",
      region: "SUCRE",
    },
    {
      city: "PALMITO",
      region: "SUCRE",
    },
    {
      city: "SAMPUES",
      region: "SUCRE",
    },
    {
      city: "SAN BENITO ABAD",
      region: "SUCRE",
    },
    {
      city: "SAN JUAN DE BETULIA",
      region: "SUCRE",
    },
    {
      city: "SAN MARCOS",
      region: "SUCRE",
    },
    {
      city: "SAN ONOFRE",
      region: "SUCRE",
    },
    {
      city: "SAN PEDRO",
      region: "SUCRE",
    },
    {
      city: "SAN LUIS DE SINCE",
      region: "SUCRE",
    },
    {
      city: "SUCRE",
      region: "SUCRE",
    },
    {
      city: "SANTIAGO DE TOLU",
      region: "SUCRE",
    },
    {
      city: "TOLU VIEJO",
      region: "SUCRE",
    },
    {
      city: "IBAGUE",
      region: "TOLIMA",
    },
    {
      city: "ALPUJARRA",
      region: "TOLIMA",
    },
    {
      city: "ALVARADO",
      region: "TOLIMA",
    },
    {
      city: "AMBALEMA",
      region: "TOLIMA",
    },
    {
      city: "ANZOATEGUI",
      region: "TOLIMA",
    },
    {
      city: "ARMERO GUAYABAL",
      region: "TOLIMA",
    },
    {
      city: "ATACO",
      region: "TOLIMA",
    },
    {
      city: "CAJAMARCA",
      region: "TOLIMA",
    },
    {
      city: "CARMEN DE APICALA",
      region: "TOLIMA",
    },
    {
      city: "CASABIANCA",
      region: "TOLIMA",
    },
    {
      city: "CHAPARRAL",
      region: "TOLIMA",
    },
    {
      city: "COELLO",
      region: "TOLIMA",
    },
    {
      city: "COYAIMA",
      region: "TOLIMA",
    },
    {
      city: "CUNDAY",
      region: "TOLIMA",
    },
    {
      city: "DOLORES",
      region: "TOLIMA",
    },
    {
      city: "ESPINAL",
      region: "TOLIMA",
    },
    {
      city: "FALAN",
      region: "TOLIMA",
    },
    {
      city: "FLANDES",
      region: "TOLIMA",
    },
    {
      city: "FRESNO",
      region: "TOLIMA",
    },
    {
      city: "GUAMO",
      region: "TOLIMA",
    },
    {
      city: "HERVEO",
      region: "TOLIMA",
    },
    {
      city: "HONDA",
      region: "TOLIMA",
    },
    {
      city: "ICONONZO",
      region: "TOLIMA",
    },
    {
      city: "LERIDA",
      region: "TOLIMA",
    },
    {
      city: "LIBANO",
      region: "TOLIMA",
    },
    {
      city: "SAN SEBASTIAN DE MARIQUITA",
      region: "TOLIMA",
    },
    {
      city: "MELGAR",
      region: "TOLIMA",
    },
    {
      city: "MURILLO",
      region: "TOLIMA",
    },
    {
      city: "NATAGAIMA",
      region: "TOLIMA",
    },
    {
      city: "ORTEGA",
      region: "TOLIMA",
    },
    {
      city: "PALOCABILDO",
      region: "TOLIMA",
    },
    {
      city: "PIEDRAS",
      region: "TOLIMA",
    },
    {
      city: "PLANADAS",
      region: "TOLIMA",
    },
    {
      city: "PRADO",
      region: "TOLIMA",
    },
    {
      city: "PURIFICACION",
      region: "TOLIMA",
    },
    {
      city: "RIOBLANCO",
      region: "TOLIMA",
    },
    {
      city: "RONCESVALLES",
      region: "TOLIMA",
    },
    {
      city: "ROVIRA",
      region: "TOLIMA",
    },
    {
      city: "SALDANA",
      region: "TOLIMA",
    },
    {
      city: "SAN ANTONIO",
      region: "TOLIMA",
    },
    {
      city: "SAN LUIS",
      region: "TOLIMA",
    },
    {
      city: "SANTA ISABEL",
      region: "TOLIMA",
    },
    {
      city: "SUAREZ",
      region: "TOLIMA",
    },
    {
      city: "VALLE DE SAN JUAN",
      region: "TOLIMA",
    },
    {
      city: "VENADILLO",
      region: "TOLIMA",
    },
    {
      city: "VILLAHERMOSA",
      region: "TOLIMA",
    },
    {
      city: "VILLARRICA",
      region: "TOLIMA",
    },
    {
      city: "CALI",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ALCALA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ANDALUCIA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ANSERMANUEVO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ARGELIA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "BOLIVAR",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "BUENAVENTURA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "GUADALAJARA DE BUGA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "BUGALAGRANDE",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "CAICEDONIA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "CALIMA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "CANDELARIA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "CARTAGO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "DAGUA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "EL AGUILA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "EL CAIRO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "EL CERRITO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "EL DOVIO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "FLORIDA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "GINEBRA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "GUACARI",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "JAMUNDI",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "LA CUMBRE",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "LA UNION",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "LA VICTORIA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "OBANDO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "PALMIRA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "PRADERA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "RESTREPO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "RIOFRIO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ROLDANILLO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "SAN PEDRO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "SEVILLA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "TORO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "TRUJILLO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "TULUA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ULLOA",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "VERSALLES",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "VIJES",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "YOTOCO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "YUMBO",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ZARZAL",
      region: "VALLE DEL CAUCA",
    },
    {
      city: "ARAUCA",
      region: "ARAUCA",
    },
    {
      city: "ARAUQUITA",
      region: "ARAUCA",
    },
    {
      city: "CRAVO NORTE",
      region: "ARAUCA",
    },
    {
      city: "FORTUL",
      region: "ARAUCA",
    },
    {
      city: "PUERTO RONDON",
      region: "ARAUCA",
    },
    {
      city: "SARAVENA",
      region: "ARAUCA",
    },
    {
      city: "TAME",
      region: "ARAUCA",
    },
    {
      city: "YOPAL",
      region: "CASANARE",
    },
    {
      city: "AGUAZUL",
      region: "CASANARE",
    },
    {
      city: "MONTERREY",
      region: "CASANARE",
    },
    {
      city: "OROCUE",
      region: "CASANARE",
    },
    {
      city: "SACAMA",
      region: "CASANARE",
    },
    {
      city: "TAURAMENA",
      region: "CASANARE",
    },
    {
      city: "VILLANUEVA",
      region: "CASANARE",
    },
    {
      city: "MANI",
      region: "CASANARE",
    },
    {
      city: "MOCOA",
      region: "PUTUMAYO",
    },
    {
      city: "COLON",
      region: "PUTUMAYO",
    },
    {
      city: "ORITO",
      region: "PUTUMAYO",
    },
    {
      city: "PUERTO ASIS",
      region: "PUTUMAYO",
    },
    {
      city: "PUERTO CAICEDO",
      region: "PUTUMAYO",
    },
    {
      city: "PUERTO GUZMAN",
      region: "PUTUMAYO",
    },
    {
      city: "PUERTO LEGUIZAMO",
      region: "PUTUMAYO",
    },
    {
      city: "SIBUNDOY",
      region: "PUTUMAYO",
    },
    {
      city: "SAN FRANCISCO",
      region: "PUTUMAYO",
    },
    {
      city: "SAN MIGUEL",
      region: "PUTUMAYO",
    },
    {
      city: "SANTIAGO",
      region: "PUTUMAYO",
    },
    {
      city: "VALLE DEL GUAMUEZ",
      region: "PUTUMAYO",
    },
    {
      city: "VILLAGARZON",
      region: "PUTUMAYO",
    },
    {
      city: "SAN ANDRES 1",
      region: "ARCHIPIELAGO DE SAN ANDRES PROVIDENCIA Y SANTA CATALINA",
    },
    {
      city: "PROVIDENCIA",
      region: "ARCHIPIELAGO DE SAN ANDRES, PROVIDENCIA Y SANTA CATALINA",
    },
    {
      city: "LETICIA",
      region: "AMAZONAS",
    },
    {
      city: "PUERTO NARINO",
      region: "AMAZONAS",
    },
    {
      city: "INIRIDA",
      region: "GUAINIA",
    },
    {
      city: "SAN JOSE DEL GUAVIARE",
      region: "GUAVIARE",
    },
    {
      city: "CALAMAR",
      region: "GUAVIARE",
    },
    {
      city: "EL RETORNO",
      region: "GUAVIARE",
    },
    {
      city: "MIRAFLORES",
      region: "GUAVIARE",
    },
    {
      city: "MITU",
      region: "VAUPES",
    },
    {
      city: "CARURU",
      region: "VAUPES",
    },
    {
      city: "TARAIRA",
      region: "VAUPES",
    },
    {
      city: "PUERTO CARRENO",
      region: "VICHADA",
    },
    {
      city: "LA PRIMAVERA",
      region: "VICHADA",
    },
    {
      city: "SANTA ROSALIA",
      region: "VICHADA",
    },
    {
      city: "CUMARIBO",
      region: "VICHADA",
    },
  ],
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function useCityRegionData() {
  const cityRegionData = ref<ICityRegionMapping[]>([]);
  const isLoading = ref(true);
  const error = ref<string | null>(null);

  const loadData = async () => {
    try {
      cityRegionData.value = cityRegionJson.cities;
      isLoading.value = false;
    } catch (e) {
      error.value = "Error loading region-city data";
      isLoading.value = false;
    }
  };

  onMounted(() => {
    loadData();
  });

  return {
    cityRegionData,
    isLoading,
    error,
  };
}
